import React, { useState, useRef, useEffect } from 'react';
import { Chat } from '@hm/hm-design-mobile';
import { ChatRef } from '@hm/hm-design-mobile/es/components/chat';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import './index.scss';
import QAvatarImg from '../../static/images_ae/qAvatar.png';
import styles from '../../component/image-picker/styles';
const Apis = new ApiCore();

const ChatPage = (props: any) => {


    const [tagList, setTagList] = useState<any>([])
    const chatRef = useRef<ChatRef>(null)

    const aAvatar = <div className='aAvatar' />
    const qAvatar = <img className='qAvatar' src={QAvatarImg} alt="" />

    useEffect(() => {
        window.document.title = '智能问答';
    }, [])


    useEffect(() => {
        getRandomInfo();
        getTags();
    }, [])

    // 获取随机问答信息
    const getRandomInfo = () => {
        Apis.getQaRandom().then((res: any) => {
            if (res.code === 0) {
                if (res.data && res.data.length > 0) {
                    let messageDom = (
                        <div >
                            <div className='answer-title'>
                                你好，我是智能问答小助手，您在遇到症状时有什么问题，可以问我哦。
                            </div>
                            <div className='answer-sub-title'> 您可以这样问我： </div>
                            <ul>
                                {
                                    res.data.map((v: any, i: number) => (
                                        <li onClick={() => viewAnswer(v)} key={i} >{v.content}</li>
                                    ))
                                }
                            </ul>
                        </div>
                    );
                    chatRef.current?.sendMessage('A', messageDom);
                }
            }
        });
    }

    // 获取提问标签
    const getTags = () => {
        Apis.getQaTags().then((res: any) => {
            if (res.code === 0) {
                let tags: any = [];
                (res.data || []).forEach((v: any) => {
                    let tag = {
                        value: v.code,
                        label: v.name
                    };
                    tags.push(tag);
                });
                setTagList(tags);
            }
        })

    }

    // 搜索回答
    const searchAnswer = (label: string = '', value: string = '') => {
        if (chatRef.current) {
            if (label) {
                chatRef.current.sendMessage('Q', label);
            }
            const _token = localStorage.getItem('token');
            if (!_token) {
                return;
            }
            const mToken = JSON.parse(_token);
            let params = {
                content: label,
                tenantCode: mToken.tenantCode
            };
            Apis.getQaSearch(params).then((res: any) => {
                if (res.code === 0) {
                    if (res.data && res.data.length > 0) {
                        let messageDom = (
                            <div >
                                <div className='title recommend' >为您推荐的回答</div>
                                <ul>
                                    {
                                        res.data.map((v: any, i: number) => (
                                            <li onClick={() => viewAnswer(v)} key={i} >{v.content}</li>
                                        ))
                                    }
                                </ul>
                            </div>
                        );
                        chatRef.current?.sendMessage('A', messageDom);
                    } else {
                        let messageDom = (
                            <div className='answer-title'>
                                您的这个问题已超出我的学习范围了，您可进一步咨询您的主治医生哦~
                            </div>
                        );
                        chatRef.current?.sendMessage('A', messageDom);
                        setTimeout(() => {
                            let messageDomAgain = (
                                <div className='answer-title'>
                                    如果以上回答都无法解答您的问题，<span className='high_light' onClick={clickThis}>点击此处</span>向我们反馈您的问题，我们会尽可能对您的上报的问题进行反馈。
                                </div>
                            );
                            chatRef.current?.sendMessage('A', messageDomAgain);
                        }, 500);
                    }
                } else {
                    Toast.show({
                        content: res.message,
                        duration: 2
                    })
                }
            })
        }
    }

    // 查看答案信息
    const viewAnswer = (data: any) => {
        if (chatRef.current) {
            let messageDom = (
                <div >
                    <div className='title' style={{ color: '#4C307D' }}>{data.answer}</div>
                    <div className='readTip'>{data.conclusion}</div>
                </div>
            );
            chatRef.current.sendMessage('Q', data.content);
            chatRef.current.sendMessage('A', messageDom);
        }
    }


    // 问题列表点击某个固定问题
    const onSelect = (value: any) => {
        searchAnswer(value.label, value.value);
    }

    // 获取到输入的值
    const onSend = (value: string) => {
        if (chatRef.current) {
            searchAnswer(value);
        }
    }

    const clickThis = () => {
        props.history.push('/ae/chart/report');
    }

    return (
        <div className='chat_container'>
            <div className='chat_proposal'>问答内容仅供参考，请遵从医生的诊断意见</div>
            <Chat ref={chatRef} aAvatar={aAvatar} qAvatar={qAvatar} send={value => onSend(value)}>
                {tagList.length > 0 &&
                    <Chat.Collapse
                        collapseList={tagList}
                        onSelect={onSelect}
                        limit={3}
                    />
                }
            </Chat>
        </div>
    )
}

export default ChatPage;